import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {GalleryModalComponent} from '../../shared/galleryModal/item';
import {AppService} from 'app/services/app.service';
import {File} from 'app/entities/file.entity';
import {File as FileSDK} from '../../../../../chat-sdk/src/entities/file';

@Component({
  selector: 'app-avatar',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class AvatarComponent implements OnInit {

  @Input() size: 'tiny' | 'small' | 'less-than-medium' | 'medium' | 'big' = 'medium';
  @Input() img: File | FileSDK = null;
  @Input() alt: string = null;
  @Input() onShift = false;
  @Input() progressBarMax = 0;
  @Input() progressBarCurrent = 0;
  @Input() slim = false;
  @Input() borderNone = false;
  @Input() ignoreClickEvent = false;

  appService: AppService;

  public defaultAvatar = 'assets/icons/avatar.svg';
  public defaultSlimAvatar = 'assets/icons/avatar-slim.svg';

  sizes = ['tiny', 'small', 'medium', 'big'];

  // соответствует ['tiny', 'small', 'medium', 'big']:
  progressbarRadius = [13, 16, 25, 70.5];
  progressbarStroke = [2, 2, 2, 3];

  constructor(
    appService: AppService
  ) {
    this.appService = appService;
  }

  @HostBinding('class')
  get classes() {
    return {
      [`avatar-size-${this.size}`]: this.size,
    };
  }

  ngOnInit(): void {

  }

  openFullViewModal(event) {
    if (this.img && !this.ignoreClickEvent && this.img instanceof File) {

      event.stopPropagation();
      this.appService.appModalService.openGalleryModal([this.img], 0);
    }
  }
}
